<template>
  <div class="sub-page">
    <div class="sub-page-title">
      <span
        @click="$router.push(`/user/safe/list`)"
        class="link">安全中心</span>
      <!--      <i class="iconfont icon-jinru"></i>-->
      <span class="ivu-breadcrumb-item-separator">/</span>
      <span>修改密码</span>
    </div>
    <Steps
      :index="stepIndex"
      :value="['身份验证', '修改密码', '完成']" />
    <Step1
      v-if="stepIndex===1"
      @success="stepIndex=2" />
    <Step2
      v-if="stepIndex===2"
      @success="stepIndex=3" />
    <Step3 v-if="stepIndex===3" />
  </div>
</template>

<script>
import Steps from '@/components/steps';
import Step1 from './step/step1';
import Step2 from './step/step2';
import Step3 from './step/step3';
export default {
  name: 'Index',
  components: {Steps, Step1, Step2, Step3},
  data() {
    return {
      stepIndex: 1,
    };
  },
};
</script>
